// Components - UI
import Scroller from '@/components/ui/Scroller/Scroller.vue';
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';

// Services
import RetailersService from '@/services/RetailersService.js';
import ServiceProvidersService from '@/services/ServiceProvidersService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

// EventBus
import { EventBus } from '@/EventBus.js'

export default {

  name: 'ServiceRelationships',

  components: {
    Scroller,
    UserIcon
  },

  data: function() {
    return {
      userMode: null,
      viewMode: null,

      // Existing Connection Data
      selectedServiceRelationship: null,
      selectedServiceProviderName: null,
      serviceRelationships: [],
      serviceAreas: ServiceRelationshipsService.serviceAreas,
      serviceAreaOn: [],

      // New Connection Data
      serviceProviders: [],
      selectedServiceProvider: null,
      newRelationship: this.initNewRelationship(),

      // Service Provider Add retailer
      retailerHumanId: null,
      retailers: null,
      selectedRetailer: null
    }
  },

  created: function() {
    this.bindEvents();

    this.init();

    // Fill an array of default area states (all off)
    for (var i = 0; i < this.serviceAreas.length; i++) {
      this.serviceAreaOn[i] = false;
    }
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    // View Mode methods
    // ---------------------------------------------------------------------------
    bindEvents: function() {
      // Listen for File Delete Events
      EventBus.$on('connectionDeleteYesClicked', (data) => {
        ServiceRelationshipsService.deleteById(data.serviceRelationshipId).then((res) => {
          // Refresh folder
          this.init();
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Something went wrong whilst deleting the connection, please check and try again...');
          // Refresh folder
          this.init();
        });
      });
    },

    init: function() {
      if(localStorage.getItem('userGroup') && localStorage.getItem('userGroup') == 'service-providers') {
        this.userMode = 'service-providers';
      }
      else {
        this.userMode = 'normal';
      }

      // Reset component data
      this.selectedServiceRelationship = null;
      this.selectedServiceProviderName = null;
      this.selectedRetailer = null;
      this.retailerHumanId = null;
      this.retailers = null;
      this.serviceRelationships = [];
      this.serviceAreaOn = [];
      this.serviceProviders = [];
      this.selectedServiceProvider = null;

      this.loadRelationships();
    },

    loadRelationships: function() {
      let id = null;

      if(this.$route.params.id) {
        // Get the retailer id from the url
        id = this.$route.params.id;
      }
      else if(localStorage.getItem('parentId')) {
        id = localStorage.getItem('parentId');
      }

      let filter = null;
      if(this.userMode == 'service-providers') {
        filter = {
          serviceProvider: id,
          status: 'pending'
        };
      }
      else {
        filter = {
          retailer: id
        };
      }

      if(id) {
        // Load service relationships for this retailer
        ServiceRelationshipsService.getAll(filter)
        .then((res) => {
          let filteredData = res.data.filter((item) => item.status != 'declined');
          this.serviceRelationships = filteredData;
        });
      }
      else {
        EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      }
    },

    onViewRelationshipClick: function(index) {
      this.selectedServiceRelationship = this.serviceRelationships[index];
      this.selectedServiceProviderName = this.serviceRelationships[index].serviceProvider.name;

      for (var i = 0; i < this.serviceAreas.length; i++) {
        this.serviceAreaOn[i] = this.selectedServiceRelationship[this.serviceAreas[i].name];
      }
    },

    deleteCurrentServiceRelationship: function() {
      let serviceRelationshipId = this.selectedServiceRelationship.id;

      let message = 'Are you sure you want to delete this connection?';

      let options = [
        {
          optionText:'Yes',
          optionEvent:'connectionDeleteYesClicked',
          optionData: {
            serviceRelationshipId: serviceRelationshipId
          }
        },
        {
          optionText:'No',
          optionEvent:'connectionDeleteNoClicked',
          optionData: null
        }
      ];

      EventBus.dispatchDialogEvent(message, options);
    },

    approveCurrentServiceRelationship: function() {
      ServiceRelationshipsService.replace(this.selectedServiceRelationship.id, {status: 'approved'})
        .then((res) => {
          this.init();
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
    },

    declineCurrentServiceRelationship: function() {
      ServiceRelationshipsService.replace(this.selectedServiceRelationship.id, {status: 'declined'})
        .then((res) => {
          this.init();
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
    },


    // Add Mode Methods
    // ---------------------------------------------------------------------------
    getServiceProviders: function() {
      ServiceProvidersService.getAll()
        .then((res) => {
          this.serviceProviders = res.data;
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
    },

    initNewRelationship: function() {
      let newRelationship = {
        accessibility: false,
        baby: false,
        bins: false,
        doors: false,
        driers: false,
        heating: false,
        lighting: false,
        mirror: false,
        paint: false,
        toiletpaper: false,
        sanitarybins: false,
        sinks: false,
        smell: false,
        soap: false,
        suggestions: false,
        toilet: false,
        towels: false,
        urinals: false,
        vending: false,
        walls: false
      }

      return newRelationship;
    },

    onViewServiceProviderClick: function(index) {
      this.selectedServiceProvider = this.serviceProviders[index];
      this.newRelationship = this.initNewRelationship();
    },

    setAllRelationshipAreasTrue: function() {
      for(let i in this.serviceAreas) {
        if(!this.unavailableServiceAreas[this.serviceAreas[i].name]) {
          this.setNewRelationshipArea(this.serviceAreas[i], true);
        }
      }
    },

    setNewRelationshipArea: function (serviceArea, state) {
      this.newRelationship[serviceArea.name] = state;
    },

    sendConnectionRequest: function() {
      this.newRelationship.status = 'pending';

      if(localStorage.getItem('userGroup') == 'service-providers') {
        this.newRelationship.serviceProvider = localStorage.getItem('parentId');
        this.newRelationship.retailer = this.selectedRetailer.id;
        this.newRelationship.origin = 'service-provider';
      }
      else {
        this.newRelationship.serviceProvider = this.selectedServiceProvider.id;
        this.newRelationship.retailer = localStorage.getItem('parentId');
        this.newRelationship.origin = 'retailer';
      }

      ServiceRelationshipsService.createOne(this.newRelationship)
        .then((res) => {
          this.viewMode = null;
          this.selectedServiceProvider = null;
          this.newRelationship = this.initNewRelationship();
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
    },

    cancelConnectionRequest: function() {
      this.viewMode = null;
      this.selectedServiceProvider = null;
      this.newRelationship = this.initNewRelationship();
    },

    searchRetailerHumanId: function () {
      console.log('this.retailerHumanId', this.retailerHumanId);

      RetailersService.getAll({humanId: this.retailerHumanId})
        .then((res) => {
          if(res.data && res.data.length > 0) {
            this.retailers = res.data;
          }
          else {
            EventBus.dispatchDialogEvent('The ID provided didn\'t match any retailer, please check the ID and try again.');
          }
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst looking up the retailer, please try again...');
        });
    },

    onViewRetailerClick: function(index) {
      this.selectedRetailer = this.retailers[index];
      this.newRelationship = this.initNewRelationship();
    },
  },

  computed: {
    isNewConnectionDirty: function() {
      let result = false;

      for(let area in this.newRelationship) {
        if (this.newRelationship[area] == true) {
          result = true;
        }
      }

      return result;
    },

    pendingServiceRelationships: function() {
      return this.serviceRelationships.filter((sr) => sr.status === 'pending');
    },

    existingServiceProviders: function() {
      let existingServiceProvderIds = [];

      for (let i in this.serviceRelationships) {
        existingServiceProvderIds.push(this.serviceRelationships[i].serviceProvider.id);
      }

      return existingServiceProvderIds;
    },

    unavailableServiceAreas: function () {
      let combinedRelationship = {
        accessibility: false,
        baby: false,
        bins: false,
        doors: false,
        driers: false,
        heating: false,
        lighting: false,
        mirror: false,
        paint: false,
        toiletpaper: false,
        sanitarybins: false,
        sinks: false,
        smell: false,
        soap: false,
        suggestions: false,
        toilet: false,
        towels: false,
        urinals: false,
        vending: false,
        walls: false
      };

      for(let i in this.serviceRelationships) {
        for(let j in combinedRelationship) {
          if(this.serviceRelationships[i][j] === true) {
            combinedRelationship[j] = true;
          }
        }
      }

      return combinedRelationship;
    },

    incomingConnectionsCount: function() {
      let incomingConnections = null;

      if(this.userMode == 'service-providers') {
        incomingConnections = this.serviceRelationships.filter((item) => {
          if(item.status == 'pending' && item.origin == 'retailer') {
            return true;
          }

          return false;
        })
      }
      else {
        incomingConnections = this.serviceRelationships.filter((item) => {
          if(item.status == 'pending' && item.origin == 'service-provider') {
            return true;
          }

          return false;
        });
      }

      return incomingConnections.length;
    },

    connectionsCount: function() {
      let incomingConnections = null;

      if(this.userMode == 'service-providers') {
        incomingConnections = this.serviceRelationships.filter((item) => {
          if(item.status == 'pending' && item.origin == 'service-provider') {
            return true;
          }

          return false;
        })
      }
      else {
        incomingConnections = this.serviceRelationships.filter((item) => {
          if((item.status == 'pending' && item.origin != 'service-provider') || item.status == 'approved' || item.status == 'declined') {
            return true;
          }

          return false;
        });
      }

      return incomingConnections.length;
    }
  },

  watch: {
    'viewMode' (to, from) {
      if(to === 'add') {
        this.getServiceProviders();
      }
      else if(to === null) {
        this.init();
      }
    },

    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ServiceRelationships/ServiceRelationships.js